import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/inventory_/purchase-orders/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
